import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Say `}<a href="mailto:caio.fleury.r@gmail.com" target="_blank" style={{
        "color": "#00a5dd"
      }}>{`Hi`}</a>{` or find me on other platforms:`}<br /><a href="https://www.linkedin.com/in/caio-fleury/" target="_blank" style={{
        "color": "#00a5dd"
      }}>{`LinkedIn`}</a>{`, `}<a href="https://github.com/CaioF" target="_blank" style={{
        "color": "#00a5dd"
      }}>{`GitHub`}</a>{` & `}<a href="https://www.kaggle.com/caiofleury" target="_blank" style={{
        "color": "#00a5dd"
      }}>{`Kaggle`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      